/**
 * Reads `routingKey` from account-shaped API payloads (login, account/change, etc.).
 * @param {unknown} data - Raw API response body
 * @returns {unknown} routingKey when present on the payload or nested account
 */
export function extractRoutingKeyFromAccountResponse(data: unknown): unknown {
  if (!data || typeof data !== "object") {
    return undefined;
  }

  const record = data as Record<string, unknown>;
  if ("routingKey" in record) {
    return record.routingKey;
  }

  const account = record.account;
  if (Array.isArray(account)) {
    for (const item of account) {
      if (item && typeof item === "object" && "routingKey" in item) {
        return (item as { routingKey?: unknown }).routingKey;
      }
    }
    return undefined;
  }

  if (account && typeof account === "object" && "routingKey" in account) {
    return (account as { routingKey?: unknown }).routingKey;
  }

  return undefined;
}

/**
 * Whether the portal should show Draft / Activate stamp card seasoning UI.
 * Enabled only for account routingKey "B" (case-insensitive).
 * @param {unknown} routingKey - Account routingKey from login / account payload
 * @returns {boolean} True when stamp card seasoning should be available
 */
export function isMilestoneSeasonEnabled(routingKey: unknown): boolean {
  if (routingKey == null || routingKey === "null") {
    return false;
  }
  if (typeof routingKey !== "string") {
    return false;
  }
  return routingKey.trim().toLowerCase() === "b";
}
